module.exports = __webpack_public_path__ + "static/media/map_base@2x.953f55cd.png";